export default () => {
    const forms = document.querySelectorAll('.get-in-touch-form');

    forms.forEach(form => {
        const msg = form.querySelector('.form-error');

        form.addEventListener('submit', function (event) {
            event.preventDefault();

            const formData = new FormData(form);
            const action = form.getAttribute('action');
            const siteKey = document.querySelector('body').getAttribute('recaptcha-site-key');

            grecaptcha.execute(siteKey, {action: 'submit'}).then(function (token) {
                formData.append('g-recaptcha-response', token);
                fetch(action, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        if (data.success) {
                            form.reset();
                            msg.classList.add('active');
                            msg.innerText = 'Thanks, we\'ve received your submission';
                        } else {
                            msg.innerText = data.message || 'An error occurred';
                        }
                        // Scroll to the message
                        msg.scrollIntoView({behavior: 'smooth'});
                    })
                    .catch(error => {
                        console.error('Error occurred:', error);
                        msg.innerText = 'An error occurred while submitting the form';
                        // Scroll to the error message
                        msg.scrollIntoView({behavior: 'smooth'});
                    });
            });
        });
    });
}
